<template>
    <!-- <el-container style="width:100%"> -->
<el-main>
    <td-permission :permissions="permissionsQuery">
        <div slot="havePermission">
            <!-- <el-row> -->
                <el-form :inline="true" :model="formFileStorage" ref="formFileStorage" class="demo-form-inline" :label-position="labelPosition" :label-width="formLabelWidth">
                <el-form-item :label="$t('common.SERVICE_FLAG')" prop="serviceId">
                        <td-input v-model="formFileStorage.serviceId"></td-input>
                </el-form-item>
                    <el-form-item :label="$t('common.SERVICE_NAME')" prop="serviceName">
                        <td-input v-model="formFileStorage.serviceName"></td-input>
                </el-form-item>
                <el-form-item style="padding-left:10px">
                    <td-button :permissions="permissionsQuery" @getPermissionsStatus="getPermissionsStatus" type="primary" :loading="queryloading" @click="queryByCondition">{{ $t('common.QUERY') }}</td-button>
                    <td-button :permissions="permissionsEdit" :loading="editloading" @click="btnBatchEdit">{{ $t('common.BATCH_EDIT') }}</td-button>
                </el-form-item>
            </el-form>
            <!-- </el-row> -->
        </div>
    </td-permission>
    <!-- 加载表格 -->
    <!-- <el-row> -->
        <td-table
            :columns="columns"
            :dataSource="tableData"
            :pageSize="pageSize"
            :hasMutiSelect="true"
            :currentPage="currentPage"
            :total="total"
            :rowKey="rowKey"
            ref="configInfo"
            @handleSizeChange="handleSizeChange"
            @currentChange="currentChange"
            :hasLoading="hasLoading"
            v-show="queryShow"
        ></td-table>
    <!-- </el-row> -->
    <!-- 加载dialog -->
    <dialog-config
        v-if="dialogVisible"
        :dialogVisible="dialogVisible"
        :editItem="editItem"
        :editItems="editItems"
        :title="dialogTitle"
        @submit="submit"
        @configDialogClose="configDialogClose"
    ></dialog-config>
</el-main>
    <!-- </el-container> -->
</template>

<script>
import Api from './assets/api.js';
import dialogEditInfo from './components/dialogEditInfo.vue';
export default {
    // 初始化渲染
    components: {
        'dialog-config': dialogEditInfo
    },
    // 在页面渲染完成之后进行初始化工作
    mounted() {},
    // 定义数据
    data() {
        return {
            formFileStorage:{
                serviceId:'',
                serviceName:''
            },
            formLabelWidth: '70px',
            permissionsQuery: ['serviceSetup:view'],
            permissionsEdit: ['serviceSetup:edit'],
            rowKey: 'id',
            queryShow: true,
            editItem: '',
            dialogVisible: false,
            tableData: [],
            pageSize: 10, // 每页条数
            currentPage: 1, // 当前页
            total: 0, // 总条数
            queryloading: false, // 按钮是否为加载状态
            editloading:false,

            hasLoading: false,
            columns: [
                {
                    prop: 'serviceId',
                    label: 'common.SERVICE_FLAG'
                },
                {
                    prop: 'serviceName',
                    label: 'common.SERVICE_NAME'
                },
                {
                    prop: 'fileServerName',
                    label: 'common.FILE_SERVER_NAME'
                },
                {
                    prop: 'fileServerIP',
                    label: 'common.FILE_SERVER_IP',
                    align: 'center'
                },
                {
                    prop: 'storagePort',
                    label: 'common.STORAGE_PORT',
                    align: 'center'
                },
                {
                    prop: 'httpPort',
                    label: 'common.STORAGE_SETUP_PORT',
                    align: 'center'
                },
                {
                    prop: 'filePort',
                    label: 'common.FILE_NGINX_PORT',
                    align: 'center'
                },

                {
                    prop: '',
                    label: 'common.OPERATE',
                    tableWidth: '150',
                    align: 'center',
                    render: (createElement, params) => {
                        return createElement('div', [
                            createElement(
                                'td-button',
                                {
                                    props: { type: 'text', size: 'small', permissions: ['serviceSetup:edit'] },
                                    on: {
                                        click: () => {
                                            this.btnEdit(params.row);
                                        }
                                    }
                                },
                                this.$t('common.EDIT')
                            )
                        ]);
                    }
                }
            ]
        };
    },
    // 方法的实现
    methods: {
        // 获取每页条数
        handleSizeChange(pageSize) {
            this.currentPage = 1;
            this.pageSize = pageSize;
            this.submit();
        },
        queryByCondition() {
            this.currentPage = 1;
            this.queryConfigInfos();
        },
        // 查询数据
        queryConfigInfos() {
            let param = {
                serviceId:this.formFileStorage.serviceId,
                serviceName:this.formFileStorage.serviceName,
                currentPage: this.currentPage,
                pageSize: this.pageSize,
                isPage: true
            };
            this.hasLoading = true;
            this.queryloading = true;
            Api.queryConfigInfos(JSON.stringify(param), response => {
                this.hasLoading = false;
                this.queryloading = false;
                if (null === response || null === response.data) {
                    return;
                }
                if (response.status !== this.$common.login.RESPONSE_STATUS) {
                    return;
                }
                if (response.data.statusCode !== this.$common.requestCode.SUCCESS_INFO_CODE) {
                    this.$message({ showClose: true, message: response.data.statusMessage, type: 'error' });
                    return;
                }
                this.tableData = response.data.content;
                this.total = response.data.count;
            });
        },
        //页面权限设置
        getPermissionsStatus(permissions) {
            if (permissions) {
                this.queryShow = true;
                this.btnQuery(); // 进行页面初始化数据的加载
            } else {
                this.queryShow = false;
            }
        },
        // 获取当前页
        currentChange(currentPage) {
            this.currentPage = currentPage;
            this.submit();
        },
        // 查询数据
        btnQuery() {
            this.currentPage = 1;
            this.queryConfigInfos();
        },
        // 编辑
        btnEdit(row) {
            this.editItems = [];
            this.editItem = row;
            this.dialogTitle = this.$t('common.EDIT');
            this.dialogVisible = true;
        },
        // 获取nodeId
        getSelects() {
            let ids = this.$refs.configInfo.getSelectAllRows();
            let content = [];
            for (let i = 0; i < ids.length; i++) {
                let temValue = ids[i];
                let select = { id: temValue.id,serviceName:temValue.serviceName,fileServerIP:temValue.fileServerIP};
                content.push(select);
            }
            return content;
        },
        // 编辑
        btnBatchEdit() {
            let params = this.getSelects();
            if (!params.length) {
                this.$message({ showClose: true, message: this.$t('message.PLEASE_CHOOSE_CONFIG_INFO'), type: 'warning' });
                return;
            }
            this.editItem = null;
            this.editItems = params;
            this.dialogTitle = this.$t('common.EDIT');
            this.dialogVisible = true;
        },
        // 组件关闭需要调用的方法
        submit() {
            this.queryConfigInfos();
        },
        // 关闭详细页面
        configDialogClose() {
            this.dialogVisible = false;
        }
    }
};
</script>
